var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"margin-top":"30px"},attrs:{"width":"100%","src":_vm.$config.analyticUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }